// src/components/Footer/Footer.js
import React, { useState } from "react";
import "./Footer.css";

const footerLinks = {
  "COMPANY": ["About Us", "Careers", "Press", "Sustainability", "Store Locator", "Blog"],
  "HELP": ["Track Order", "Returns & Exchange", "Size Guide", "FAQ", "Contact Us", "Shipping Policy"],
  "POLICIES": ["Privacy Policy", "Terms of Use", "Cookie Policy", "Refund Policy", "Accessibility"],
  "SHOP": ["Men", "Women", "Sneakers", "Collectibles", "Accessories", "Gift Cards"],
};

export default function Footer() {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = () => {
    if (email.includes("@")) { setSubscribed(true); setEmail(""); }
  };

  return (
    <footer className="footer">
      {/* App banner */}
      <div className="footer__app-banner">
        <div className="container footer__app-inner">
          <div>
            <h3 className="footer__app-title">GET THE APP</h3>
            <p className="footer__app-sub">Earn 10% cashback on every app order + early access to new drops</p>
          </div>
          <div className="footer__app-btns">
            <a className="footer__store-btn footer__store-btn--play" href="#">
              <span>▶</span>
              <div><span>GET IT ON</span><span>Google Play</span></div>
            </a>
            <a className="footer__store-btn footer__store-btn--apple" href="#">
              <span style={{ fontSize: 20 }}>&#xf8ff;</span>
              <div><span>Download on the</span><span>App Store</span></div>
            </a>
          </div>
        </div>
      </div>

      {/* Newsletter */}
      <div className="footer__newsletter">
        <div className="container footer__newsletter-inner">
          <div>
            <h3 className="footer__nl-title">STAY IN THE LOOP</h3>
            <p className="footer__nl-sub">Get early access to drops, exclusive deals & fan collections</p>
          </div>
          <div className="footer__nl-form">
            {!subscribed ? (
              <>
                <input
                  className="footer__nl-input"
                  type="email" placeholder="Enter your email"
                  value={email} onChange={e => setEmail(e.target.value)}
                  onKeyDown={e => e.key === "Enter" && handleSubscribe()}
                />
                <button className="footer__nl-btn" onClick={handleSubscribe}>SUBSCRIBE</button>
              </>
            ) : (
              <p className="footer__nl-success">🎉 Thanks for subscribing!</p>
            )}
          </div>
        </div>
      </div>

      {/* Main footer */}
      <div className="footer__main">
        <div className="container footer__grid">
          {/* Brand col */}
          <div className="footer__brand">
            <div className="footer__logo">
              <svg viewBox="0 0 48 52" fill="none" width="44" height="48">
                <ellipse cx="24" cy="20" rx="15" ry="16" fill="none" stroke="white" strokeWidth="2.5"/>
                <circle cx="17" cy="15" r="3.5" fill="white"/>
                <circle cx="31" cy="15" r="3.5" fill="white"/>
                <path d="M17 25 Q24 31 31 25" stroke="white" strokeWidth="2" fill="none"/>
                <path d="M9 36 L24 36 L39 36 L39 52 L30 46 L24 52 L18 46 L9 52 Z" fill="white"/>
              </svg>
              <div>
                <div className="footer__logo-name">The Souled Store</div>
                <div className="footer__logo-member">MEMBER</div>
              </div>
            </div>
            <p className="footer__brand-desc">
              India's biggest officially licensed merchandise brand. Pop culture meets streetwear since 2013. 200+ licenses.
            </p>
            <div className="footer__social">
              {[
                { name: "Instagram", icon: "📸" },
                { name: "Facebook", icon: "👥" },
                { name: "Twitter", icon: "🐦" },
                { name: "YouTube", icon: "▶" },
              ].map(s => (
                <button key={s.name} className="footer__social-btn" title={s.name}>{s.icon}</button>
              ))}
            </div>
          </div>

          {/* Link columns */}
          {Object.entries(footerLinks).map(([section, links]) => (
            <div key={section} className="footer__links-col">
              <h4 className="footer__links-title">{section}</h4>
              {links.map(link => (
                <a key={link} href="#" className="footer__link">{link}</a>
              ))}
            </div>
          ))}
        </div>

        {/* Trust badges */}
        <div className="container">
          <div className="footer__trust">
            {[
              { icon: "🚚", text: "Free Delivery on prepaid ₹445+" },
              { icon: "🔄", text: "30-Day Exchange Policy" },
              { icon: "🔒", text: "100% Secure Payments" },
              { icon: "📏", text: "XS to 5XL Sizes" },
              { icon: "✅", text: "200+ Official Licenses" },
              { icon: "🌿", text: "Bio-washed Premium Fabric" },
            ].map(b => (
              <div key={b.text} className="footer__trust-item">
                <span className="footer__trust-icon">{b.icon}</span>
                <span>{b.text}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom bar */}
        <div className="footer__bottom">
          <div className="container footer__bottom-inner">
            <p>© 2026 The Souled Store. All rights reserved.</p>
            <div className="footer__pay-icons">
              {["UPI", "Visa", "MC", "Amex", "PayTM", "COD"].map(p => (
                <span key={p} className="footer__pay-icon">{p}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
